(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  const vrHeaderObservers = new WeakMap();
  function setupVrHeader(scope) {
    const header = scope.querySelector('x-header.vr-header');
    if (!header || vrHeaderObservers.has(header)) return;
    const list = header.querySelector('.vr-header-category-list');
    const top = header.querySelector('.vr-header-top-list');
    if (!list) return;
    const wide = window.matchMedia('(min-width: 1280px)');
    let frame;
    const widthOf = element => element ? element.getBoundingClientRect().width : 0;
    const rowWidth = element => {
      if (!element) return 0;
      const gap = parseFloat(getComputedStyle(element).columnGap) || 0;
      return Array.from(element.children).reduce((sum, child) => sum + widthOf(child), 0) + Math.max(0, element.children.length - 1) * gap;
    };
    const fit = () => {
      if (!wide.matches) { header.classList.remove('vr-header--compact'); return; }
      const style = getComputedStyle(header);
      const available = header.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);
      const side = Math.max(widthOf(header.querySelector('.header__logo')), widthOf(header.querySelector('.header__secondary-nav')));
      const compact = rowWidth(list) + 8 > available || rowWidth(top) + side * 2 + 48 > available;
      if (compact && !header.classList.contains('vr-header--compact')) {
        header.querySelectorAll('dropdown-menu-disclosure, mega-menu-disclosure').forEach(menu => menu.toggle?.(false));
      }
      header.classList.toggle('vr-header--compact', compact);
    };
    const schedule = () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(fit); };
    const observer = new ResizeObserver(schedule);
    const updateObservation = () => {
      observer.disconnect();
      if (wide.matches) {
        observer.observe(header);
        Array.from(list.children).forEach(item => observer.observe(item));
        if (top) Array.from(top.children).forEach(item => observer.observe(item));
      }
      schedule();
    };
    wide.addEventListener('change', updateObservation);
    document.fonts.ready.then(() => { if (header.isConnected && wide.matches) schedule(); });
    vrHeaderObservers.set(header, () => { observer.disconnect(); wide.removeEventListener('change', updateObservation); cancelAnimationFrame(frame); });
    updateObservation();
  }
  setupVrHeader(document);
  document.addEventListener('shopify:section:load', event => setupVrHeader(event.target));
  document.addEventListener('shopify:section:unload', event => {
    const header = event.target.querySelector('x-header.vr-header');
    vrHeaderObservers.get(header)?.();
    if (header) vrHeaderObservers.delete(header);
  });

  } catch(e) { console.error(e); }
})();
})();
